import dynamic from 'next/dynamic';
import ViewJobDialog from './ViewJobDialog';
export const ViewJobDialogDynamic = dynamic(
  () => import('./ViewJobDialog' /* webpackChunkName: "ViewJobDialog" */),
  { ssr: false }
) as typeof ViewJobDialog;
